import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'
import LazyLoader from '../lazy-loading/LazyLoader'

const trackerHandler = (title, url, idx, quicklinkDestination, quicklinkType) => {
  if (typeof window === 'undefined') return true

  let eventLabel

  eventLabel = {
    Title: title,
    Position: idx + 1,
    Link: url
  }
  Analytics.send('Homepage', 'Quick link clicked', eventLabel)

  tracker.trackEvent('userevent', {
    type: 'Quick Link Clicked',
    quick_link_title: title,
    quick_link_url: url,
    quick_link_position: idx + 1,
    quick_link_destination: quicklinkDestination,
    quick_link_type: quicklinkType,
    user: window.inSidedData.user
  })
  return true
}

const QuickLink = props => {
  const { item, borderRadius, enableBorder, isVisibleDesktop } = props
  let { idx } = props
  const { iconSrc, imageSrc, title, url, openNewTab, description } = item
  const style = { borderRadius: borderRadius ? borderRadius + 'px' : '0' }
  const quicklinkHeroClassName = iconSrc ? 'padding__icon quicklink__hero' : 'quicklink__hero'
  const quicklinkDestination = typeof window !== 'undefined' && url.indexOf(window.location?.hostname) > -1 ? 'internal' : 'external'
  const urlTarget = openNewTab ? '_blank' : ''
  let quicklinkBoxClassName = ''
  quicklinkBoxClassName += enableBorder ? ' has-border' : ''
  quicklinkBoxClassName += !isVisibleDesktop ? ' is-hidden-mobile-up' : ''

  let quicklinkType = ''
  if (imageSrc) {
    quicklinkType = 'image'
  } else if (iconSrc) {
    quicklinkType = 'icon'
  } else {
    quicklinkType = 'text'
  }

  return (
    <article
      class={`featured-topic quicklink__box${quicklinkBoxClassName} card-widget-wrapper`}
      style={style}>
      <a
        href={url}
        onClick={() => trackerHandler(title, url, idx, quicklinkDestination, quicklinkType)}
        class='quicklink__url'
        tabIndex='0'
        target={urlTarget}>
        {iconSrc || imageSrc
          ? (
            <figure className={iconSrc ? 'figure-padding__icon' : ''}>
              <LazyLoader
                type='background'
                src={iconSrc || imageSrc}
                classNames={quicklinkHeroClassName}
                alt={`Quicklink image ${idx + 1}`}
              />
            </figure>
          )
          : null }
        <div class='quicklink__title'>
          <header><h3 class='card-widget-title'>{title}</h3></header>
          <p class='text--meta card-widget-text'>{ description }</p>
        </div>
      </a>
    </article>
  )
}

export default QuickLink
